import { Amplify, Auth } from 'aws-amplify'
import awsconfig from '../../aws-exports'

Amplify.configure(awsconfig)

// Invite User
// Required: Username(*Email) and Password
export async function signUp({
  email,
  username,
  firstName,
  lastName,
  password,
  clientOrganization,
  clientRole,
}) {
  try {
    return await Auth.signUp({
      username,
      password,
      firstName,
      lastName,
      attributes: {
        email,
        'custom:clientName': clientOrganization,
        'custom:userType': clientRole,
      },
      autoSignIn: {
        // optional - enables auto sign in after user is confirmed
        enabled: false,
      },
    })
  } catch (error) {
    return error
  }
}

// This is used to confirm an invite for a new user.
export async function completeNewPassword(userData, newPassword) {
  return Auth.signIn(userData.email, userData.code).then((response) => {
    /* When AWS Cognito requires new password,
       call the completeNewPassword API to reset it */
    if (response.challengeName === 'NEW_PASSWORD_REQUIRED') {
      Auth.completeNewPassword(response, newPassword, {
        'custom:firstName': userData.firstName,
        'custom:lastName': userData.lastName,
      })
    }
  })
}

// Send Confirmation Code and Email That Was Invited To Confirm Sign Up
export async function confirmSignUp({ username, code, firstName, lastName }) {
  return Auth.confirmSignUp(username, code).then(() => {
    updateUser({ firstName, lastName })
  })
}

// Update User Attributes With Additional Info
export async function updateUser({ firstName, lastName }) {
  try {
    const user = await Auth.currentAuthenticatedUser()
    return await Auth.updateUserAttributes(user, {
      'custom:firstName': firstName,
      'custom:lastName': lastName,
    })
  } catch (e) {
    return e
  }
}

// Edge Case To Account For Users Who Do Not Confirm Code Within 24 Hours
export async function resendConfirmationCode({ username }) {
  try {
    return await Auth.resendSignUp(username)
  } catch (err) {
    return err
  }
}
